export const VIEWER_LOCALES = ["en", "es", "fr", "de", "it", "pt", "ru", "zh", "ja", "ko"] as const;

export type ViewerLocale = (typeof VIEWER_LOCALES)[number];

export const DEFAULT_LOCALE: ViewerLocale = "en";

const INTL_LOCALES: Record<ViewerLocale, string> = {
  en: "en-US",
  es: "es-ES",
  fr: "fr-FR",
  de: "de-DE",
  it: "it-IT",
  pt: "pt-PT",
  ru: "ru-RU",
  zh: "zh-CN",
  ja: "ja-JP",
  ko: "ko-KR",
};

export function isViewerLocale(code: string | null | undefined): code is ViewerLocale {
  return typeof code === "string" && (VIEWER_LOCALES as readonly string[]).includes(code);
}

export function uiLocaleFor(language: string | null | undefined): ViewerLocale {
  return isViewerLocale(language) ? language : DEFAULT_LOCALE;
}

export function intlLocaleFor(language: string | null | undefined): string {
  if (isViewerLocale(language)) return INTL_LOCALES[language];
  if (language && /^[a-z]{2}$/.test(language)) {
    try {
      const [supported] = Intl.NumberFormat.supportedLocalesOf(language);
      if (supported) return supported;
    } catch {
      return INTL_LOCALES[DEFAULT_LOCALE];
    }
  }
  return INTL_LOCALES[DEFAULT_LOCALE];
}
